import ArticleMap from './article-mapping.js';
export default class ArticleMapper {
    getArticle(articleName, context) {
        const articleData = ArticleMap[articleName];
        if (!articleData)
            return null;
        // First try to find an article with a matching condition
        const matchingArticle = articleData.articles.find((item) => {
            if (item.condition) {
                return context[item.condition] === true;
            }
            return false; // Skip articles without conditions in first pass
        });
        // If no matching condition found, look for the default article (no condition property)
        const defaultArticle = matchingArticle || articleData.articles.find((item) => !('condition' in item));
        return defaultArticle ? { articleLink: defaultArticle.articleLink, articleNumber: defaultArticle.articleNumber } : null;
    }
    getResponsibleTeam(articleName) {
        var _a;
        return (_a = ArticleMap[articleName]) === null || _a === void 0 ? void 0 : _a.team;
    }
}
